import { ApiError } from '@/services/api';

/**
 * true quando o erro é "este endpoint ainda não existe" (404 ou 405).
 *
 * Separa a ausência de backend — que a tela mostra como estado explícito
 * "aguardando backend" — de uma falha real de leitura (403, 500, rede), que é
 * alarme. Confundir as duas foi como uma tela chegou a parecer pronta.
 */
export function ehEndpointAusente(erro: unknown): boolean {
  return erro instanceof ApiError && (erro.status === 404 || erro.status === 405);
}
